var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-header" }, [
    _c("div", { staticClass: "page-header-content" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c(
            "el-page-header",
            { attrs: { content: _vm.title }, on: { back: _vm.handleBack } },
            [
              _c(
                "div",
                {
                  staticClass: "title-content",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("span", { staticClass: "title-text" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _vm._v(" "),
                  _vm.tag
                    ? _c("span", { class: ["tag", _vm.tagType] }, [
                        _vm._v(_vm._s(_vm.tag)),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.extra
                ? _c(
                    "div",
                    { attrs: { slot: "extra" }, slot: "extra" },
                    [_vm._t("extra")],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.content || _vm.$slots.content
            ? _c(
                "div",
                { staticClass: "desc" },
                [
                  _vm._t("content", function () {
                    return [_vm._v(_vm._s(_vm.content))]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$slots.default || _vm.$slots.action
        ? _c(
            "div",
            { staticClass: "right" },
            [
              _vm._t("action", function () {
                return [_vm._t("default")]
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }